import SessionQrDisplayPageActionTypes from './session-qr-display-page-action-types';

export const setSessionQrDisplayDisabled = (disabled) => ({
  type: SessionQrDisplayPageActionTypes.SET_SESSION_QR_DISPLAY_DISABLED,
  payload: { disabled }
});

export const loadSessionQrDisplay = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: SessionQrDisplayPageActionTypes.LOAD_SESSION_QR_DISPLAY_START });
  try {
    const qr = await api.get(`api/general_competency_events/${payload.eventId}/sessions/${payload.sessionId}/qr`);
    if (qr?.validFrom) {
      qr.validFrom = new Date(qr.validFrom);
    }
    if (qr?.validUntil) {
      qr.validUntil = new Date(qr.validUntil);
    }
    dispatch({
      type: SessionQrDisplayPageActionTypes.LOAD_SESSION_QR_DISPLAY_END,
      payload: { qr: qr || null }
    });
  } catch (error) {
    dispatch({ type: SessionQrDisplayPageActionTypes.LOAD_SESSION_QR_DISPLAY_END });
    throw error;
  }
};
